import { i18n } from 'translate/i18n'
import { DropItemViewProps } from './DropItem.types'
import { useMemo } from 'react'

export function useDropItemInfo(props: DropItemViewProps) {
  const intl =
    props.dropOrAsset[i18n.language as LanguageCodes] || props.dropOrAsset
  const image =
    'asset' in props.dropOrAsset
      ? props.dropOrAsset.media?.image || (props.dropOrAsset?.media.icon ?? props.dropOrAsset?.image)
      : props.dropOrAsset.media.imageUrl
  const { currency, price, prices } = useMemo(() => {
    let currency: string | undefined
    let price: number | undefined
    let prices: { [c: string]: number } | undefined
    if ('unitPrice' in props.dropOrAsset) {
      currency = props.dropOrAsset.currency
      price = props.dropOrAsset.unitPrice
      prices = props.dropOrAsset.prices!
    } else if ('price' in props.dropOrAsset) {
      currency = Object.keys(props.dropOrAsset.price)[0]
      price = props.dropOrAsset.price[currency]!.lowest!
      prices = {
        [currency]: price,
      }
    }
    return {
      currency,
      price,
      prices,
    }
  }, [])

  return {
    intl,
    image,
    currency,
    price,
    prices,
    isCvm: 'type' in props.dropOrAsset && props.dropOrAsset.type === 'cvm88',
  }
}
